import { render } from "./PresentacionesAdminView.vue?vue&type=template&id=4209c3fc&ts=true"
import script from "./PresentacionesAdminView.vue?vue&type=script&lang=ts"
export * from "./PresentacionesAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__